export const mainMeta = (canonical?: string) => {
  const meta = {
    title: 'Пресс-служба АО «РоссельхозБанк» | Новости Банка',
    main: {
      description:
        'Узнавайте о новых банковских продуктах и услугах на сайте АО «РоссельхозБанк». ' +
        'Пресс-релизы. Читайте новости Банка и будьте в курсе последних событий экосистемы «Своё».',
      canonical,
    },
    og: {
      get title() {
        return meta.title;
      },
      get description() {
        return meta.main.description;
      },
      get url() {
        return meta.main.canonical;
      },
    },
    get twitter() {
      return meta.og;
    },
  };

  return meta;
};

export const premiumUltraMeta = (canonical?: string) => {
  const meta = {
    title: 'Новости и акции разделов «Премиум» и «Ультра» – АО «РоссельхозБанк»',
    main: {
      description:
        'Узнавайте свежие новости о премиальном обслуживании от АО «РоссельхозБанк». ' +
        'Будьте в курсе выгодных акций по пакетам услуг «Премиум» и «Ультра». Информация для клиентов премиум обслуживания.',
      canonical,
    },
    og: {
      get title() {
        return meta.title;
      },
      get description() {
        return meta.main.description;
      },
      get url() {
        return meta.main.canonical;
      },
    },
    get twitter() {
      return meta.og;
    },
  };

  return meta;
};
